/** Prefix every document editor instance's element id starts with. */
export const EDITOR_ID_PREFIX = "agreementDocumentEditor-";

/**
 * Remove the Syncfusion spell-checker caches left in localStorage.
 *
 * The editor caches every word it has checked under
 * `<element id>_<guid>`. Our element id is unique per mount and the guid is
 * new for every instance, so no cache is ever read back — each opened
 * document just left another orphan behind until a write blew past the
 * storage quota (QuotaExceededError from `setItem`). The editor swallows that
 * once, clears its own key and retries, and the retry threw uncaught.
 *
 * Every editor cache goes: the element id repeats across mounts (React's
 * useId), so a previous document's cache cannot be told apart by key, and
 * a freshly mounted editor has written nothing yet.
 */
export function pruneEditorStorage(): void {
  try {
    const stale: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      // Syncfusion also persists each editor's review-pane Tab under
      // "tab" + the editor id, which piles up one tiny key per mount.
      if (
        !key ||
        !(
          key.startsWith(EDITOR_ID_PREFIX) ||
          key.startsWith(`tab${EDITOR_ID_PREFIX}`)
        )
      )
        continue;
      stale.push(key);
    }
    stale.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Storage unavailable (private mode, disabled) — nothing to prune.
  }
}
